import { SET_DEFAULT_PAGE_SIZE } from './types';

export default function setDefaultPageSize(pageSize) {
  return {
    type: SET_DEFAULT_PAGE_SIZE,
    payload: pageSize,
  };
}
